import { ProjectsCreateDialog } from '@/components/dialogs/projects/create'
import { useUser } from '@/contexts/auth/user'

export const NewProjectAction = () => {
  const { user } = useUser()

  if (!user?.is_admin && !user?.is_root) {
    return null
  }

  return <ProjectsCreateDialog />
}
